'use client'

import { useEffect, useRef } from 'react'

/** Same permalink as vanishinginc-dev/mystify-collaboration/submit/Default.aspx */
const ZOHO_FORM_SRC =
  'https://forms.zohopublic.com/vanishinginc/form/MagicTrickSubmissionFormforVanishingIncMystifyColl/formperma/csL2GWwncWxYF9v0tAJhzOfllzR415ZXwuQwIy_63x4?zf_rszfm=1'

const INITIAL_HEIGHT_PX = 2144

/**
 * Zoho public form embed with postMessage height resize (ported from legacy ASP.NET FooterJavascript).
 */
export function MystifyZohoFormEmbed() {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      const evntData = event.data
      if (!evntData || typeof evntData !== 'string') return

      const zf_ifrm_data = evntData.split('|')
      if (zf_ifrm_data.length !== 2 && zf_ifrm_data.length !== 3) return

      const container = containerRef.current
      if (!container) return

      const iframe = container.getElementsByTagName('iframe')[0]
      if (!iframe) return

      const zf_perma = zf_ifrm_data[0]
      const zf_ifrm_ht_nw = `${parseInt(zf_ifrm_data[1], 10) + 15}px`

      if (
        iframe.src.indexOf('formperma') <= 0 ||
        iframe.src.indexOf(zf_perma) <= 0
      ) {
        return
      }

      const prevIframeHeight = iframe.style.height
      let zf_tout = false
      if (zf_ifrm_data.length === 3) {
        iframe.scrollIntoView()
        zf_tout = true
      }
      if (prevIframeHeight !== zf_ifrm_ht_nw) {
        if (zf_tout) {
          setTimeout(() => {
            iframe.style.height = zf_ifrm_ht_nw
          }, 500)
        } else {
          iframe.style.height = zf_ifrm_ht_nw
        }
      }
    }

    window.addEventListener('message', onMessage, false)
    return () => window.removeEventListener('message', onMessage, false)
  }, [])

  return (
    <div
      ref={containerRef}
      id="zf_div_csL2GWwncWxYF9v0tAJhzOfllzR415ZXwuQwIy_63x4"
      className="flex w-full justify-center px-2 pb-8 pt-2 md:px-4"
    >
      <iframe
        src={ZOHO_FORM_SRC}
        title="Magic Trick Submission Form for Vanishing Inc. / Mystify Collaboration"
        className="border-0 transition-all duration-500"
        style={{
          height: `${INITIAL_HEIGHT_PX}px`,
          width: '90%',
          maxWidth: '100%',
        }}
        allow="camera; microphone"
      />
    </div>
  )
}
